import { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/scss/modal-video.scss";
import Frequentation from "./frequentation";
import Emargement from "./emargement";
import EmargementJournalier from "./emargementJournalier";
import FicheNote from "./ficheNote";
import ListeClasse from "./listeClasse";
import "./docs.css";

const AllDocs = () => {
  const [selectedPage, setSelectedPage] = useState("frequentation");

  return (
    <>
      <div className="main-chat-blk">
        <div className="main-wrapper">
          <div className="page-wrapper chat-page-wrapper">
            <div className="content">
              {/* sidebar group */}
              <div
                className="sidebar-group left-sidebar chat_sidebar"
                style={{
                  borderRight: "1px solid #B5B9C3",
                  borderTop: "1px solid #B5B9C3",
                }}
              >
                {/* Chats sidebar */}
                <div id="chats" className="left-sidebar-wrap sidebar active">
                  <Scrollbars>
                    <div className="slimscroll-active-sidebar">
                      {/* Left Chat Title */}
                      <div
                        className="left-chat-title all-chats d-flex justify-content-between align-items-center"
                        style={{ borderBottom: "1px solid #B5B9C3" }}
                      >
                        <div className="setting-title-head">
                          <h4> Tous les Documents</h4>
                        </div>
                        <div className="add-section">
                          <ul>
                            <li>
                              <div className="chat-action-btns">
                                <div className="chat-action-col">
                                  <Link
                                    className="#"
                                    to="#"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="bx bx-dots-vertical-rounded" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <Link to="#" className="dropdown-item ">
                                      <span>
                                        <i className="bx bx-message-rounded-add" />
                                      </span>
                                      New Chat{" "}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/* /Left Chat Title */}
                      <div className="sidebar-body chat-body" id="chatsidebar">
                        <>
                          <ul className="mb-3">
                            <li className="mb-3 list-unstyled">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="video-call-tooltip">
                                    Certificat de Fréquentation
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  className={`d-flex align-items-center p-2 border rounded transition-all text-decoration-none ${
                                    selectedPage === "frequentation"
                                      ? "active-item"
                                      : "bg-light-hover"
                                  }`}
                                  aria-label="Lancer un appel vidéo"
                                  onClick={() =>
                                    setSelectedPage("frequentation")
                                  }
                                >
                                  <div
                                    className={`rounded-circle p-2 me-3 ${
                                      selectedPage === "frequentation"
                                        ? "bg-primary text-white"
                                        : "bg-primary-light"
                                    }`}
                                  >
                                    <i className="ti ti-file-certificate fs-4" />
                                  </div>

                                  <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-semibold text-truncate">
                                      Certificat de Fréquentation
                                    </h6>
                                    <small className="text-muted">
                                      Cliquez pour générer
                                    </small>
                                  </div>

                                  <div className="ms-2">
                                    <i className="bx bx-chevron-right" />
                                  </div>
                                </Link>
                              </OverlayTrigger>
                            </li>

                            <li className="mb-3 list-unstyled">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-emargement">
                                    Fiche d'émargement
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  className={`d-flex align-items-center p-2 border rounded transition-all text-decoration-none ${
                                    selectedPage === "emargement"
                                      ? "active-item"
                                      : "bg-light-hover"
                                  }`}
                                  aria-label="Fiche d'émargement"
                                  onClick={() => setSelectedPage("emargement")}
                                >
                                  <div
                                    className={`rounded-circle p-2 me-3 ${
                                      selectedPage === "emargement"
                                        ? "bg-primary text-white"
                                        : "bg-primary-light"
                                    }`}
                                  >
                                    <i className="ti ti-clipboard-check fs-4" />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-semibold text-truncate">
                                      Fiche d'émargement
                                    </h6>
                                    <small className="text-muted">
                                      Cliquez pour générer
                                    </small>
                                  </div>
                                  <div className="ms-2">
                                    <i className="bx bx-chevron-right" />
                                  </div>
                                </Link>
                              </OverlayTrigger>
                            </li>

                            <li className="mb-3 list-unstyled">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-emargement-journalier">
                                    Fiche d'émargement Journalier
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  className={`d-flex align-items-center p-2 border rounded transition-all text-decoration-none ${
                                    selectedPage === "emargementJournalier"
                                      ? "active-item"
                                      : "bg-light-hover"
                                  }`}
                                  aria-label="Fiche d'émargement Journalier"
                                  onClick={() =>
                                    setSelectedPage("emargementJournalier")
                                  }
                                >
                                  <div
                                    className={`rounded-circle p-2 me-3 ${
                                      selectedPage === "emargementJournalier"
                                        ? "bg-primary text-white"
                                        : "bg-primary-light"
                                    }`}
                                  >
                                    <i className="ti ti-calendar fs-4" />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-semibold text-truncate">
                                      Fiche d'émargement Journalier
                                    </h6>
                                    <small className="text-muted">
                                      Cliquez pour générer
                                    </small>
                                  </div>
                                  <div className="ms-2">
                                    <i className="bx bx-chevron-right" />
                                  </div>
                                </Link>
                              </OverlayTrigger>
                            </li>

                            <li className="mb-3 list-unstyled">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-fiche-note">
                                    Fiche de note
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  className={`d-flex align-items-center p-2 border rounded transition-all text-decoration-none ${
                                    selectedPage === "ficheNote"
                                      ? "active-item"
                                      : "bg-light-hover"
                                  }`}
                                  aria-label="Fiche de note"
                                  onClick={() => setSelectedPage("ficheNote")}
                                >
                                  <div
                                    className={`rounded-circle p-2 me-3 ${
                                      selectedPage === "ficheNote"
                                        ? "bg-primary text-white"
                                        : "bg-primary-light"
                                    }`}
                                  >
                                    <i className="ion ion-clipboard fs-4" />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-semibold text-truncate">
                                      Fiche de note
                                    </h6>
                                    <small className="text-muted">
                                      Cliquez pour générer
                                    </small>
                                  </div>
                                  <div className="ms-2">
                                    <i className="bx bx-chevron-right" />
                                  </div>
                                </Link>
                              </OverlayTrigger>
                            </li>

                            <li className="mb-3 list-unstyled">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-liste-classe">
                                    Liste de classe
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  className={`d-flex align-items-center p-2 border rounded transition-all text-decoration-none ${
                                    selectedPage === "listeClasse"
                                      ? "active-item"
                                      : "bg-light-hover"
                                  }`}
                                  aria-label="Liste de classe"
                                  onClick={() => setSelectedPage("listeClasse")}
                                >
                                  <div
                                    className={`rounded-circle p-2 me-3 ${
                                      selectedPage === "listeClasse"
                                        ? "bg-primary text-white"
                                        : "bg-primary-light"
                                    }`}
                                  >
                                    <i className="ion ion-clipboard fs-4" />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-semibold text-truncate">
                                      Liste de classe
                                    </h6>
                                    <small className="text-muted">
                                      Cliquez pour générer
                                    </small>
                                  </div>
                                  <div className="ms-2">
                                    <i className="bx bx-chevron-right" />
                                  </div>
                                </Link>
                              </OverlayTrigger>
                            </li>
                          </ul>
                          {/* Left Chat Title */}
                        </>
                      </div>
                    </div>
                  </Scrollbars>
                </div>
                {/* / Chats sidebar */}
              </div>
              {/* /Sidebar group */}

              {selectedPage === "frequentation" ? (
                <Frequentation />
              ) : selectedPage === "emargement" ? (
                <Emargement />
              ) : selectedPage === "emargementJournalier" ? (
                <EmargementJournalier />
              ) : selectedPage === "ficheNote" ? (
                <FicheNote />
              ) : selectedPage === "listeClasse" ? (
                <ListeClasse />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllDocs;
